import app from './app'
import auth from './auth'
import user from './user'
import catalogs from './catalogs'

export default {
  app,
  auth,
  user,
  catalogs
}



// WEBPACK FOOTER //
// ./src/store/modules/index.js